import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { RBACContext } from "@/lib/rbac/context";
import { getLandingPath } from "@/lib/rbac/landing";

interface ProtectedRouteProps {
  permission?: string;
  children: React.ReactNode;
}

export function ProtectedRoute({ permission, children }: ProtectedRouteProps) {
  const { hasPermission, isLoading } = useContext(RBACContext);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  // When a user hits a page they're not allowed on, bounce them to
  // the most-useful page they CAN access -- not a hardcoded
  // ``/dashboard`` that many roles can't see either (which would loop
  // or render a zero-filled dashboard like it used to for leads).
  if (permission && !hasPermission(permission)) {
    return <Navigate to={getLandingPath(hasPermission)} replace />;
  }

  return <>{children}</>;
}
